import { useState } from "react";
import { useAuth } from "../auth/useAuth";
import { useNavigate } from "react-router-dom";
import PublicPageLayout from "../components/publicSite/PublicPageLayout";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const handleLogin = async () => {
    setLoading(true); setError("");
    try { await login(); navigate("/dashboard"); }
    catch { setError("Accesso non riuscito. Riprova."); }
    finally { setLoading(false); }
  };
  return <PublicPageLayout title="Area riservata" eyebrow="Gestione del parco">
    <section className="login-panel" aria-label="Accesso alla gestione">
      <p>Accedi per gestire gare, campionati e concorrenti del Parco della Sciola.</p>
      <button type="button" className="site-button" onClick={handleLogin} disabled={loading}>{loading ? "Accesso in corso…" : "Accedi all’area riservata"}</button>
      {error && <p role="alert" className="site-notice site-notice--error mt-6">{error}</p>}
    </section>
  </PublicPageLayout>;
}
